import type { Task } from "@app/core";

/**
 * If `t` is a virtual occurrence synthesized from a recurrence rule, return the
 * source Task row that the dialog should edit. Real tasks are returned as-is.
 */
export function resolveSource(t: Task, all: ReadonlyArray<Task>): Task {
  if (t.virtual && t.parent_id) {
    const parent = all.find((x) => x.id === t.parent_id);
    if (parent) return parent;
  }
  return t;
}
